// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"5f4bfde2","587":"5f4bfde2","825":"9c6069e9","850":"3d9db72b","908":"d3b77c9b"}[chunkId] + ".chunk.css";
};